import { Message } from 'data/firestore/agent/thread/message/types';
import { ItemUser } from 'data/firestore/globals';
import Download from 'components/icons/download';
import { createDownloadLink } from 'components/SMSChat/ChatMessages/Message/MediaContent/helpers/createDownloadLink';
import getMediaComponent from './helpers/getMediaComponent';
import { MediaContainer, StyledButtonIcon } from './styled';
import { ChatBubble } from '../styled';

interface MediaProps {
    media?: Extract<Message, { role: 'user' | 'assistant' }>['media'];
    direction: 'outgoing' | 'incoming';
    role: ItemUser['role'];
    isFirst?: boolean;
    totalBubbles: number;
    contentBubbleIndex: number;
}

const Media = ({
    media = [],
    direction,
    role,
    isFirst = false,
    totalBubbles,
    contentBubbleIndex,
}: MediaProps) => {
    const validMedia = media.filter((m) => m !== undefined);

    const handleDownload = async (url: string) => {
        if (!url) return;
        try {
            await createDownloadLink(url, null);
        } catch (error) {
            // error handling
        }
    };

    return (
        <>
            {validMedia.map((mediaItem, index) => {
                const Component = getMediaComponent(mediaItem?.contentType);
                const bubbleIndex = contentBubbleIndex >= 0
                    ? contentBubbleIndex + 1 + index
                    : index;
                const isFirstBubble = isFirst && index === 0;
                const isLastBubble = bubbleIndex === totalBubbles - 1;
                const isIntermediateBubble = !isFirstBubble && !isLastBubble;

                return (
                    <MediaContainer key={mediaItem?.url || index} direction={direction}>
                        <ChatBubble
                            direction={direction}
                            role={role}
                            isFirst={isFirstBubble}
                            isLast={isLastBubble}
                            isIntermediate={isIntermediateBubble}
                        >
                            <Component url={mediaItem?.url} filename={mediaItem?.contentType} />
                        </ChatBubble>
                        {mediaItem?.url && (
                            <StyledButtonIcon
                                direction={direction}
                                size="small"
                                shaded
                                icon={<Download />}
                                onClick={() => handleDownload(mediaItem.url)}
                            />
                        )}
                    </MediaContainer>
                );
            })}
        </>
    );
};

export default Media;
